import { AGraphEdge } from 'components/Visualization/PixiGraph/core/Edge';
import { IdMap } from 'components/Visualization/PixiGraph/core/IdMap';
import { AGraphEdgeId } from 'components/Visualization/PixiGraph/core/types';

export class EdgeIdMap extends IdMap<AGraphEdgeId, AGraphEdge> {}
